import React from 'react'
import styles from './cookie-policies.scss'

const translations = {
  de: {
    duration: 'Zeitspanne',
    category: 'Kategorie',
    trigger: 'Auslöser',
    description: 'Beschreibung',
  },
  en: {
    duration: 'Druation',
    category: 'Category',
    trigger: 'Trigger',
    description: 'Description',
  },
}

export const CookieList = ({ language, list }) => {
  return list.map((cookie) => {
    let domain = cookie.domain
    if (typeof window !== 'undefined') {
      domain = domain.replace('.perspectivefunnel.com', `.${window.location.host}`)
    }

    return (
      <div className={styles.cookieEntry}>
        <p>
          <strong>Name:</strong> {cookie.name} <br />
          <strong>Service:</strong> {cookie.service.join(', ')} <br />
          <strong>Domain:</strong> {domain} <br />
          <strong>{translations[language].duration}:</strong> {cookie.duration} <br />
          <strong>{translations[language].category}:</strong> {cookie.category} <br />
          <strong>{translations[language].trigger}:</strong> {cookie.trigger} <br />
          {cookie.description && (
            <>
              <strong>{translations[language].description}:</strong> {cookie.description}
            </>
          )}
        </p>
      </div>
    )
  })
}

export default CookieList
